/*
 * UserEditForm Messages
 *
 * This contains all the text for the UserEditForm component.
 */

import { defineMessages } from "react-intl";

export const scope = "app.components.UserEditForm";

export default defineMessages({
  header: {
    id: `${scope}.header`,
    defaultMessage: "This is the UserEditForm component!",
  },
  practiceInfo: {
    id: `${scope}.practiceInfo`,
    defaultMessage: "Practice Info",
  },
  changeInformation: {
    id: "changeInformation",
    defaultMessage: "Do you want to change this information?",
  },
  thenCallReFrezh: {
    id: "ThenCallReFrezh",
    defaultMessage: "Then call ReFrezh: ",
  },
});
